import { useTranslation } from 'react-i18next';
import { ArrowDown } from 'assets/icons';
import { formatStockName } from 'utils/stock';

export default function Select({ title, options, type, value, onSelectChange, className }) {
  const { t } = useTranslation();

  return (
    <div className={`text-gray flex items-center space-x-2 m-3 relative ${className}`}>
      {title && <label>{title}</label>}
      <ArrowDown className="absolute text-sm text-gray-dark w-6 h-6 right-4 pointer-events-none" />
      <select
        className="flex-1 border rounded-lg border-gray h-11 px-3 text-gray bg-gray-light appearance-none"
        value={value}
        onChange={onSelectChange}
      >
        {/* 代號
          marketId: "1905.TW"
          marketName: "華紙"
        */}
        {type === 'symbol' &&
          options?.map((option) => (
            <option key={`option_${option.marketId}`} value={option.marketId}>
              {formatStockName(option)}
            </option>
          ))}
        {/* 策略
          StrategyProfileId: 11
          ProfileName: 'C11'
        */}
        {type === 'strategy' &&
          options?.map(({ ProfileName, StrategyProfileId }) => (
            <option key={`option_${StrategyProfileId}`} value={StrategyProfileId}>
              {ProfileName}
            </option>
          ))}
        {/* 多空 */}
        {type === 'longShort' && (
          <>
            <option value={0}>{t('AllStock.longShort')}</option>
            <option value={1}>{t('AllStock.long')}</option>
            <option value={2}>{t('AllStock.short')}</option>
          </>
        )}
      </select>
    </div>
  );
}
